<div class="d-lg-none mt-5 mt-lg-0">
  <!-- placeholder for mobile to ensure the content is not hidden by the buttons -->
  &nbsp;
</div>

<div class="container-lg">
  <div class="row justify-content-lg-end mt-lg-3 pb-lg-5">
    <div class="btns-secondary col-12 col-lg-auto d-lg-block" [class.d-none]="!showSecondaryButtons()">
      <ng-content select="[secondary]"></ng-content>
    </div>
    <div class="btns-primary col-12 col-lg-auto buttons-container d-flex">
      <ng-content></ng-content>

      @if (enableSecondary()) {
        <button type="button" class="btn btn-light d-lg-none btn-ellipsis" (click)="toggleSecondaryButtons()">
          <lucide-icon [name]="icons.verticalEllipsis"></lucide-icon>
        </button>
      }
    </div>
  </div>
</div>
